import React from "react";
// import {Permissioned} from 'react-permissions';
import SubHeader from "../../../common/subHeader";
import Divider from "../../../common/divider";
// import Permissions from '../../../../configurations/permissions';

const DisputeModalComments = props => {
  return (
    <div>
      <Divider />
      <SubHeader title="Comments" />
      <Divider />
      <div className="dispute-comments">
        <label>Comment:</label>
        <br />
        <textarea
          maxLength="250"
          className="form-control float_input"
          id="disputeComment"
          value={props.comment}
          size=""
          onChange={props.onCommentChangeHandler}
          placeholder="Add comment here"
        />
      </div>
    </div>
  );
};

export default DisputeModalComments;



// WEBPACK FOOTER //
// ./src/components/disputeMgmt/disputes/modal/disputeModalComments.js